import { ChevronRight, Code, CreditCard, Megaphone, Users } from "lucide-react"
import { landingCopy } from "../landingCopy"
import { useLandingLanguage } from "../useLandingLanguage"

const itemIcons = [Users, Code, Megaphone, CreditCard]

const cardClass =
  "rounded-[2px] border border-solid border-[#E6E6E6] transition-colors hover:border-[#8F8F8F]"

export default function LeadInterceptionSection() {
  const language = useLandingLanguage()
  const leadInterception = landingCopy(language, "leadInterception")

  return (
    <section className="ml-[calc(50vw-50%-1.5rem)] w-full">
      <div className="grid w-full grid-cols-1 items-stretch gap-6 lg:grid-cols-2">
        <div className={`flex h-full flex-col justify-between gap-8 p-8 ${cardClass}`}>
          <h2 className="text-balance text-[40px] font-bold leading-[48px] tracking-[-0.04em] text-[#171717] max-md:text-[28px] max-md:leading-8">
            {leadInterception.title}
          </h2>
          <p className="text-pretty text-[16px] font-normal leading-6 text-[#4D4D4D]">
            {leadInterception.body}
          </p>
        </div>
        <ul className="m-0 flex list-none flex-col gap-3 p-0">
          {leadInterception.items.map((item, index) => {
            const Icon = itemIcons[index]
            return (
              <li
                key={index}
                className={`flex items-center gap-3 p-6 text-[14px] font-medium leading-5 text-[#171717] ${cardClass}`}
              >
                <Icon className="size-4 shrink-0" strokeWidth={1.5} aria-hidden="true" />
                <span>
                  <span className="font-bold">{item.lead}</span>
                  {item.rest}
                </span>
                <ChevronRight className="size-3 shrink-0" strokeWidth={1.5} aria-hidden="true" />
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}
